import React, { useRef, useState, useEffect } from 'react';

type DateInputProps = {
    name: string;
    value: string;
    setValue: (value: string) => void;
    paddingBlock?: string;
    required?: boolean;
    disabled?: boolean;
}

const TimeInput = ({
    name,
    value,
    setValue,
    paddingBlock = "8px",
    required = false,
    disabled
}: DateInputProps) => {
    const timeRef = useRef<HTMLInputElement>(null);
    const buttonRef = useRef<HTMLButtonElement>(null);
    const [displayTime, setDisplayTime] = useState<string>("");

    useEffect(() => {
        setDisplayTime(value || "__:__");
    }, [value]);

    return (
        <div className="relative">
            <button
                ref={buttonRef}
                type="button"
                disabled={disabled}
                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                onClick={() => {
                    if (!disabled) timeRef.current?.showPicker();
                }}
                onFocus={() => {
                    buttonRef.current?.classList.add("!border-[#167AC3]");
                }}
                onBlur={() => {
                    buttonRef.current?.classList.remove("!border-[#167AC3]");
                }}
            >
                <span tabIndex={1} className="text-sm tracking-wide">
                    {displayTime}
                </span>

                <span className="material-symbols-outlined absolute top-1/2 right-[8px] -translate-y-1/2 text-gray-500 text-sm">schedule</span>
            </button>

            <input
                ref={timeRef}
                type="time"
                name={name}
                className="absolute inset-0 opacity-0 -z-10 pointer-events-none"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                tabIndex={-1}
                required={required}
                disabled={disabled}
            />
        </div>
    );
}

export default TimeInput;